export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative w-full h-screen min-h-[700px] flex flex-col justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/468228b08c8f3f8ae3d58e3facf34079.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-20 flex flex-col justify-center h-full pt-20">
        <div className="max-w-3xl">
          <p className="text-white/60 text-xs tracking-[0.4em] uppercase mb-6 font-medium">
            iOS Platform Specialists
          </p>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-none tracking-tight">
            <span className="block">Secure.</span>
            <span className="block mt-1">Optimize.</span>
            <span className="block mt-1 text-white/70">Elevate.</span>
          </h1>
          <p className="mt-10 text-white/70 text-base md:text-lg font-light max-w-lg leading-relaxed">
            Modern applications for the iOS platform — built by a team of dedicated
            experts to enhance your user experience and protect your mobile device.
          </p>
        </div>

        {/* Two product hints at bottom */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-16 mt-16">
          <div className="border-l border-white/30 pl-5">
            <p className="text-white/50 text-xs tracking-widest uppercase mb-1">Product</p>
            <p className="text-white font-semibold text-lg">VPN Shield</p>
            <p className="text-white/60 text-sm mt-1 font-light max-w-xs">
              Uncompromising privacy and encrypted connections for iOS.
            </p>
          </div>
          <div className="border-l border-white/30 pl-5">
            <p className="text-white/50 text-xs tracking-widest uppercase mb-1">Product</p>
            <p className="text-white font-semibold text-lg">Cleaner Pro</p>
            <p className="text-white/60 text-sm mt-1 font-light max-w-xs">
              Smart storage management and device optimization for iOS.
            </p>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent"></div>
        <p className="text-white/40 text-xs tracking-widest uppercase">Scroll</p>
      </div>
    </section>
  );
}
